module.exports = __webpack_public_path__ + "static/img/2.9d78f3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/2/2.png
// module id = 7woP
// module chunks = 1